<div class="row m-0 bg-wood">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="tab-container">
            <div class="tab-details">
                <div class="warranty-shipping-packaging-block fcbcolor">
                    <p class="header_title">{{'common.text_warranty_shipping_packaging_tab_part_return' | cxTranslate }}</p>
                    <p class="fs-20">{{'common.text_warranty_shipping_packaging_tab_product_claim' | cxTranslate }}</p>
                    <p class="fs-20">{{'common.text_warranty_shipping_packaging_tab__address' | cxTranslate }}</p>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <p class="fs-20"> <strong>{{'common.text_warranty_shipping_packaging_tab_us_address' | cxTranslate }}</strong>
                              <br>{{'common.text_warranty_shipping_packaging_tab_us_address_bendix' | cxTranslate }}
                              <br>{{'common.text_warranty_shipping_packaging_tab_us_address_bendix_line1' | cxTranslate }}
                              <br>{{'common.text_warranty_shipping_packaging_tab_us_address_bendix_line2' | cxTranslate }}<br>{{'common.text_warranty_shipping_packaging_tab_us_address_bendix_line3' | cxTranslate }}
                            </p>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <p class="fs-20"> <strong>{{'common.text_warranty_shipping_packaging_tab_canada_address' | cxTranslate }}</strong><br>{{'common.text_warranty_shipping_packaging_tab_canada_address_bendix' | cxTranslate }}<br>{{'common.text_warranty_shipping_packaging_tab_canada_address_bendix_line1' | cxTranslate }}<br>{{'common.text_warranty_shipping_packaging_tab_canada_address_bendix_line2' | cxTranslate }}<br> </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
